/*
 * Loads the coverage map's dependencies only when the map is about to be seen.
 *
 * d3, topojson-client and the two geometry files come to about 800KB together.
 * The map is one section on one page, so none of it is fetched until the map
 * scrolls near the viewport - and never at all on a phone that stops above it.
 */
(function () {
  if (window.__blCoverageMapBooted) return;
  window.__blCoverageMapBooted = true;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-bl-map-src="' + src + '"]');
      if (existing) return existing.getAttribute('data-loaded') ? resolve() : existing.addEventListener('load', resolve);
      var s = document.createElement('script');
      s.src = src;
      s.async = false; // topojson must not land before d3
      s.setAttribute('data-bl-map-src', src);
      s.addEventListener('load', function () {
        s.setAttribute('data-loaded', '1');
        resolve();
      });
      s.addEventListener('error', reject);
      document.head.appendChild(s);
    });
  }

  function boot(el) {
    if (el.__blBooting) return;
    el.__blBooting = true;
    var d3Url = el.getAttribute('data-d3-url');
    var topoUrl = el.getAttribute('data-topojson-url');
    var mapUrl = el.getAttribute('data-map-url');
    loadScript(d3Url)
      .then(function () {
        return loadScript(topoUrl);
      })
      .then(function () {
        return loadScript(mapUrl);
      })
      .catch(function () {
        // The legend and the state cards carry the same information in text,
        // so a failed map costs nothing but the picture.
        el.setAttribute('data-failed', '');
      });
  }

  function init() {
    var maps = document.querySelectorAll('coverage-map[data-d3-url]');
    if (!maps.length) return;

    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < maps.length; i++) boot(maps[i]);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          boot(entry.target);
        });
      },
      { rootMargin: '400px 0px' }
    );
    for (var j = 0; j < maps.length; j++) io.observe(maps[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
